import { Button, Modal, Text } from '@vinted/web-ui';
import { INTELLECTUAL_PROPERTY_INFRINGEMENT, LOGIN } from 'constants/routes';
import useTranslate from 'hooks/useTranslate';
import { jsx as _jsx } from "react/jsx-runtime";

const UnauthenticatedReportModal = _ref => {
  let {
    isVisible,
    onClose
  } = _ref;
  const translate = useTranslate('user.report_modal');

  const getNtdFormLink = () => /*#__PURE__*/_jsx("a", {
    href: INTELLECTUAL_PROPERTY_INFRINGEMENT,
    rel: "noreferrer",
    children: translate('reporting_platform_link')
  });

  return /*#__PURE__*/_jsx(Modal, {
    show: isVisible,
    closeOnOverlay: true,
    defaultCallback: onClose,
    title: translate('title'),
    body: /*#__PURE__*/_jsx(Text, {
      text: translate('body', {
        reporting_platform_link: getNtdFormLink()
      }),
      html: true
    }),
    testId: "report-user-modal",
    actions: [{
      text: translate('actions.login'),
      url: LOGIN,
      style: Button.Styling.Filled
    }]
  });
};

export default UnauthenticatedReportModal;